//Plugin to wire up the styles and functionality of the file upload input type. This is opinionated, so you need to follow the HTML markup structure shown on the formExample page.

import { util } from '~/core';

export default function upload(input) {
	const label = input.parentElement.querySelector('label')
	const change = function(e) {
		let selectedFile
		if (this.files && this.files.length > 1) {
			selectedFile = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length)
		}
		else if (e.target.value) {
			selectedFile = e.target.value.split('\\').pop()
		}
		if (selectedFile) {
			label.insertAdjacentHTML('beforeend', `<span class="fileUpload-fileName"><span class="fileUpload-fileIndicator">Chosen File: </span>${selectedFile}</span>`)
		}
		else {
			label.querySelector('.fileUpload-fileName').parentElement.removeChild('.fileUpload-fileName')
		}
	}
	//input.addEventListener('change', change)
	//FF bug fix
	//input.addEventListener('focus', function() { label.classList.add('has-focus')})
	//input.addEventListener('blur', function() { label.classList.remove('has-focus')})
}

//util.upload = upload